import i18next from "i18next";
import {
  Button,
  Section,
  StatLabel,
  StatNumber,
  StatsGrid,
  Title,
} from "./style";

export const TrustStatsComponent = () => {
  const { t } = i18next;

  const scrollToSearch = () => {
    const el = document.getElementById("search-form");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <Section>
      <Title>{t("trust_title")}</Title>
      <StatsGrid>
        <div>
          <StatNumber>1 000 000 +</StatNumber>
          <StatLabel>{t("trust_stat_tickets")}</StatLabel>
        </div>
        <div>
          <StatNumber>15 {t("trust_stat_years_unit")}</StatNumber>
          <StatLabel>{t("trust_stat_years")}</StatLabel>
        </div>
        <div>
          <StatNumber>24/7</StatNumber>
          <StatLabel>{t("trust_stat_support")}</StatLabel>
        </div>
      </StatsGrid>
      <Button onClick={scrollToSearch}>{t("trust_button")}</Button>
    </Section>
  );
};
